import React, { useState } from "react";
import s from "./breadcrumb.module.css"
import { Link } from 'gatsby'
import { ArrowRight } from '../../svg/arrow_right'
import { Home } from '../../svg/home'
import { GTMEvents } from "../../lib/GTMevents";

const Breadcrumb = props => {
    const [modal, setModal] = useState(false)

    const viewModal = () => {
        if(!modal) {
            setModal(true)
        } else {
            setModal(false)
        }
    }

    return (
        <>
            <div id={props.GtmContainer} className={'breadrumbWrapContainer'}>
                <div className={'containerWrap'}>
                    <ul className={'breadrumbWrap'}>
                        <li
                        onClick={() => {
                            if (props.type && props.type.length > 0) {
                                GTMEvents.TypeContributionBreadcrumbATM(props.GTMSection,'casa', 'casa - home', '/public-zone' );
                            } else {
                                GTMEvents.TypeContributionBreadcrumb(props.GTMSection,'casa', 'casa - home', '/public-zone' );
                            }
                        }} 
                        className='dib'>
                            <Link id='casa' to='/'>
                                <Home height={14} />
                            </Link>
                            <ArrowRight height={14} />
                        </li>
                        {
                            props.titlesBreadcrumb.titlesIntermediate?
                                props.titlesBreadcrumb.titlesIntermediate.map((element, _) => (                                
                                    <li 
                                    onClick={() => {
                                        if (props.type && props.type.length > 0) {
                                            GTMEvents.TypeContributionBreadcrumbATM(props.GTMSection, props.GTMTitle, element.title, props.GTMLink);
                                        } else {
                                            GTMEvents.TypeContributionBreadcrumb(props.GTMSection, props.GTMTitle, element.title, props.GTMLink);
                                        }
                                    }} 
                                    className='dn dib@md dib@lg' key={element.title}>
                                        {
                                            element.link? 
                                                <Link  to={element.link}>
                                                    <span id={props.GtmBeforeArrow}   >{element.title}</span>
                                                </Link> :
                                                <span id={props.GtmBeforeArrow} >{element.title}</span>
                                        }
                                        <ArrowRight height={14} />
                                    </li>                                    
                                )) :
                                <span></span>
                        }
                        {
                            props.titlesBreadcrumb.titlesIntermediate?
                                <li className="dib dn@md dn@lg" onClick={() => viewModal()}>
                                    <span className="cursor-pointer">...</span>
                                    <ArrowRight height={14} />
                                </li>
                                :
                                <span></span>
                        }
                        <li 
                        onClick={() => {
                            if (props.type && props.type.length > 0) {
                                GTMEvents.TypeContributionBreadcrumbATM(props.GTMSection, props.GTMTitle, props.titlesBreadcrumb.titleFinal, props.GTMLink);
                            } else {
                                GTMEvents.TypeContributionBreadcrumb(props.GTMSection, props.GTMTitle, props.titlesBreadcrumb.titleFinal, props.GTMLink);
                            }
                        }} 
                        id={props.GtmAfterArrow} className='dib'>
                            {props.titlesBreadcrumb.titleFinal}
                        </li>
                    </ul>
                </div>
            </div>
            {
                modal?
                    <div className={`${s.modalContainer} dib dn@md dn@lg z-10`}>
                        <ul className={`${s.ulContainer} db`}>
                            {
                                props.titlesBreadcrumb.titlesIntermediate.map((element, _) => (
                                        <li
                                            className={`font-family-primary fw-4 tw-f-14 c-gray--4 ${element.index == (props.titlesBreadcrumb.titlesIntermediate.length - 1)? '' : 'tw-mb-4'}`} 
                                            key={element.title}
                                        >
                                            {
                                                element.link? 
                                                    <Link to={element.link}>
                                                        <span >{element.title}</span>
                                                    </Link> :
                                                    <span >{element.title}</span>
                                            }
                                        </li>
                                ))
                            }
                        </ul>
                    </div>
                    :
                    <span></span>
            }
        </>
    )
}

export default Breadcrumb;